import { render, staticRenderFns } from "./PhotoCaptureBox.vue?vue&type=template&id=6331ffb2&scoped=true"
import script from "./PhotoCaptureBox.vue?vue&type=script&lang=js"
export * from "./PhotoCaptureBox.vue?vue&type=script&lang=js"
import style0 from "./PhotoCaptureBox.vue?vue&type=style&index=0&id=6331ffb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6331ffb2",
  null
  
)

export default component.exports